// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialIcons_socialLinks__+y2mZ","lightSocialLinks":"SocialIcons_lightSocialLinks__lBn6L","icon":"SocialIcons_icon__cbEkk"};